export function rgb(r, g, b) {
    if (arguments.length !== 3) {
        throw new Error('rgb expects (r, g, b), received:', ...arguments);
    }

    return `rgb(${r},${g},${b})`;
}
export function rgba(r, g, b, a) {
    if (arguments.length !== 4) {
        throw new Error('rgba expects (r, g, b, a), received:', ...arguments);
    }

    return `rgba(${r},${g},${b},${a})`;
}

export const white = rgb(255, 255, 255);
export const white75a = rgba(255, 255, 255, 0.75);
export const white50a = rgba(255, 255, 255, 0.5);
export const white25a = rgba(255, 255, 255, 0.25);
export const white10a = rgba(255, 255, 255, 0.1);
export const white5a = rgba(255, 255, 255, 0.05);

export const black = rgb(10, 10, 10);
export const black75a = rgba(0, 0, 0, 0.75);
export const black50a = rgba(0, 0, 0, 0.5);
export const black25a = rgba(0, 0, 0, 0.25);
export const black10a = rgba(0, 0, 0, 0.1);
export const black5a = rgba(0, 0, 0, 0.05);

export const transparent = rgba(255, 255, 255, 0);

export const brandWhite = rgb(250, 250, 251);
export const brandGreen = rgb(0, 220, 146);
export const skyblue = '#CCEEFF';

export const offwhite = rgb(246, 246, 246);
export const offwhiteAccent = rgb(255, 255, 255);

export const offblackAccent = rgb(19, 58, 157);
// export const offblack = rgb(27, 41, 85);
// export const offblack = "#265a88"
// export const offblack = rgb(44, 62, 80);
export const offblack = rgb(52, 73, 94);
export const offblack90 = rgb(35, 47, 92);
export const offblack75 = rgb(56, 66, 106);
export const offblack50 = rgb(142, 148, 170);
export const offblack25 = rgb(199, 201, 213);
export const offblack10 = rgb(222, 223, 230);
export const offblack5 = rgb(241, 241, 244);

export const offblackAccent0a = rgba(19, 58, 157, 0);
export const offblackAccent10a = rgba(19, 58, 157, 0.1);
export const offblackAccent25a = rgba(19, 58, 157, 0.25);
export const offblackAccent50a = rgba(19, 58, 157, 0.5);

export const offblack90a = rgba(27, 41, 85, 0.95);
export const offblack75a = rgba(27, 41, 85, 0.75);
export const offblack50a = rgba(27, 41, 85, 0.5);
export const offblack25a = rgba(27, 41, 85, 0.25);
export const offblack10a = rgba(27, 41, 85, 0.1);
export const offblack5a = rgba(27, 41, 85, 0.05);
export const offblack0a = rgba(27, 41, 85, 0);

export const offblack50_50a = rgba(142, 148, 170, 0.5);
export const offblack50_25a = rgba(142, 148, 170, 0.25);
export const offblack25_50a = rgba(199, 201, 213, 0.5);
export const offblack25_25a = rgba(199, 201, 213, 0.25);
export const offblack10_10a = rgba(222, 223, 230, 0.1);
export const offblack10_5a = rgba(222, 223, 230, 0.05);

export const greenAccent = rgb(0, 123, 126);
export const green = rgb(0, 224, 139);
export const green50 = rgb(74, 240, 198);
export const green25 = rgb(175, 248, 227);
export const green5 = rgb(235, 254, 247);

export const green50a = rgba(0, 224, 139, 0.5);
export const green25a = rgba(0, 224, 139, 0.25);
export const green5a = rgba(0, 224, 139, 0.05);
export const green0a = rgba(0, 224, 139, 0);

export const blueAccent = rgb(0, 113, 133);
// export const blue = rgb(0, 197, 254);
export const blue = rgb(33, 150, 243);
export const blue50 = rgb(89, 222, 255);
export const blue25 = rgb(178, 239, 255);
export const blue5 = rgb(237, 251, 255);

export const purpleAccent = rgb(79, 39, 237);
export const purple = rgb(177, 88, 255);
export const purple50 = rgb(217, 172, 255);
export const purple25 = rgb(237, 213, 255);
export const purple5 = rgb(250, 244, 255);
export const purple5a = rgba(177, 88, 255, 0.05);

export const yellowAccent = rgb(255, 125, 0);
export const yellow = rgb(255, 183, 0);
export const yellow50 = rgb(255, 212, 92);
export const yellow25 = rgb(255, 234, 171);
export const yellow5 = rgb(255, 250, 237);

export const magentaAccent = rgb(255, 120, 94);
export const magentaAccent50 = rgb(254, 192, 179);
export const magentaAccent25 = rgb(255, 223, 217);

export const magenta = rgb(255, 37, 110);
export const magenta50 = rgb(255, 133, 168);
export const magenta25 = rgb(255, 193, 211);
export const magenta5 = rgb(255, 242, 246);

export const magenta50a = rgba(255, 37, 110, 0.5);
export const magenta25a = rgba(255, 37, 110, 0.25);
export const magenta5a = rgba(255, 37, 110, 0.05);
export const magenta0a = rgba(255, 37, 110, 0);

// Alternates
export const altGreen = rgb(0, 206, 106);
export const altGreen50 = rgb(94, 231, 182);
export const altGreen25 = rgb(168, 243, 211);
export const altGreen5 = rgb(238, 253, 246);

// export const altBlue = rgb(53, 128, 255)
// export const altBlue = rgb(74, 127, 251);
export const altBlue = rgb(64, 124, 255); // 😑 profile: sRGB, meter: sRGB, display: Macbook Pro 2016
export const altBlue50 = rgb(140, 176, 255);
export const altBlue25 = rgb(197, 216, 255);
export const altBlue5 = rgb(244, 246, 255);

export const altTeal = rgb(0, 168, 182);
export const altTeal50 = rgb(96, 213, 219);
export const altTeal25 = rgb(167, 229, 232);
export const altTeal5 = rgb(237, 249, 250);

export const altPurple = rgb(228, 83, 255);
export const altPurple50 = rgb(244, 171, 255);
export const altPurple25 = rgb(248, 200, 255);
export const altPurple5 = rgb(254, 244, 254);

export const electricBlue = '#1842EF';

// Vendor palette
export const twitterPrimary = rgb(1, 159, 233);
export const facebookPrimary = rgb(46, 77, 167);
export const googlePrimary = rgb(215, 15, 37);



// WEBPACK FOOTER //
// ./src/theme/_colors.js